/** «Финансы → Расходы»: ответы ручек `/api/expense-coverage` и `/api/expense-coverage/rows`. */
import { apiFetch, query } from "@/lib/api";
import type { KassaKind } from "@/lib/kassa";
import type { Money } from "@/lib/pnl";

/** В P&L · без статьи · вне P&L · безнал не связан, есть похожая · безнал не связан, операции нет. */
export type CoverageStatus = "pnl" | "unassigned" | "outside" | "similar" | "missing";

export type Bucket = { count: number; sum: Money };

export type Coverage = {
  statuses: { code: CoverageStatus; name: string; hint: string }[];
  kinds: { code: KassaKind; name: string }[];
  /** Новые сверху. */
  months: string[];
  cells: (Bucket & { month: string; kind: KassaKind; status: CoverageStatus })[];
  totals: (Bucket & { kind: KassaKind; status: CoverageStatus })[];
  /** Безнал без операции банка: касса × тип расхода CRM; `similar` — из них с похожей операцией. */
  missing_groups: (Bucket & { kassa_id: number; kassa_name: string; type: string; similar: number })[];
};

export type CoverageOperation = {
  id: number;
  date: string;
  amount: Money;
  account: string | null;
  bank_name: string;
  entrepreneur_name: string;
  counterparty_name: string;
  purpose: string;
  article_name: string;
};

export type CoverageRow = {
  id: number;
  crm_id: number;
  date: string;
  /** Со знаком: + выдали из кассы, − вернули. */
  amount: Money;
  kassa_name: string;
  kassa_kind: KassaKind;
  location_name: string | null;
  entrepreneur_name: string | null;
  type: string;
  recipient_name: string | null;
  card_mask: string | null;
  recipient_bank: string | null;
  comment: string;
  crm_article_name: string | null;
  article_name: string | null;
  status: CoverageStatus;
  /** Связанная операция выписки — только у безнала. */
  operation: CoverageOperation | null;
  similar_count: number;
  similar: CoverageOperation[];
};

export type CoveragePage = { total: number; sum: Money; rows: CoverageRow[] };

export type CoverageFilter = {
  kind?: KassaKind | undefined;
  /** `unlinked` — отбор: безнал без связи, с похожей или без. */
  status?: CoverageStatus | "unlinked" | undefined;
  month?: string | undefined;
  kassa_id?: number | undefined;
  type?: string | undefined;
  date_from?: string | undefined;
  date_to?: string | undefined;
  limit?: number | undefined;
  offset?: number | undefined;
};

export function loadCoverage(filter: { date_from?: string | undefined; date_to?: string | undefined }): Promise<Coverage> {
  return apiFetch<Coverage>(`/api/expense-coverage${query(filter)}`);
}

export function loadCoverageRows(filter: CoverageFilter): Promise<CoveragePage> {
  return apiFetch<CoveragePage>(`/api/expense-coverage/rows${query(filter)}`);
}
